module.exports = "/_next/static/images/Wallet@2x-d95eb019ee1a8018111a0fd471dc51ff.png";